import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { StyledButton as Button } from '../../buttons/Button/Button.styled'
import {
    breakpoint,
    calcRem,
    colors,
    fonts,
    themedValue,
} from '../../__styling'
import { palette } from '../EmailPreference.styled'

export const StyledInput = styled('input')(() => ({
    display: 'block',
    textIndent: calcRem(10),
    backgroundColor: '#EAEAEA',
    height: calcRem(40),
    border: 'none',
    outline: 'none',
    width: '100%',
}))

export const StyledForm = styled('form')(() => ({
    display: 'block',
    padding: calcRem(32, 0),
    [breakpoint('lg')]: {
        width: '50%',
        padding: calcRem(64, 0),
    },
}))

export const StyledLabel = styled('label')(() => ({
    display: 'block',
    fontSize: calcRem(13),
    fontWeight: 700,
    lineHeight: calcRem(16),
    font: fonts.thewest.serif,
}))

export const StyledAsterisk = styled('span')({
    color: '#A60500',
})

export const StyledInputGroup = styled('div')({
    marginTop: calcRem(32),
})

export const StyledDisclaimer = styled('p')({
    marginTop: calcRem(32),
})

export const StyledFormHeading = styled('p')({
    fontSize: calcRem(32),
    fontWeight: 400,
    lineHeight: calcRem(40),
    margin: calcRem(0, 0, 8),
})

export const StyledFormSubHeading = styled('p')({
    fontSize: calcRem(16),
    paddingTop: calcRem(8),
})

export const StyledSuccessBody = styled('div')({
    textAlign: 'center',
    padding: calcRem(48, 0),
    [breakpoint('lg')]: {
        textAlign: 'left',
        maxWidth: calcRem(343),
    },
})

export const StyledBoldText = styled('p')({
    fontSize: calcRem(24),
    fontWeight: 700,
    marginTop: calcRem(0),
    marginBottom: calcRem(8),
    padding: calcRem(0),

    [breakpoint('lg')]: {
        textAlign: 'left',
    },
})

export const StyledText = styled('p')({
    margin: 0,
    fontSize: calcRem(16),
    fontWeight: 400,
})

export const StyledHR = styled('hr')({
    color: tokens.thewest.colors.palette.greyQuokka,
    fontWeight: 100,
})

export const StyledError = styled('p')(({ theme }) => ({
    fontSize: calcRem(14),
    color: themedValue(theme, {
        thewest: colors.thewest.engineRed,
        perthnow: colors.perthnow.redRuby,
        sevennews: colors.sevennews.red,
    }),
    margin: calcRem(48, 0, 0),
}))

export const StyledSubmitButton = styled(Button)(({ theme }) => ({
    width: '100%',
    height: calcRem(32),
    background: palette(theme)?.button?.primary.background.active,
    color: palette(theme)?.button?.primary.text.default,
    border: 'none',
}))
